import { atom } from "jotai";

export const drawerExpandedAtom = atom<boolean>(false);

export const feedbackOpen = atom<boolean>(false);
